import React, { createContext, ReactNode } from 'react';

export enum PopupType {
  ERROR,
  INFO,
  WARNING,
  SUCCESS,
}

interface Popup {
  type: PopupType;
  message: ReactNode | string | null;
  title?: string;
  cancelText?: string;
  actionText?: string;
  action?: () => void;
  cancelAction?: () => void;
}

export type PopupOptions = Omit<Popup, 'type' | 'message'>;

export interface PopupContextType {
  popup: Popup | null;
  setPopup: React.Dispatch<React.SetStateAction<Popup | null>>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PopupContext = createContext<PopupContextType>({} as any);
